/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */
import { Linkable } from '@/components/blocks/Linkable';
import {
	tileDescriptionDrawerSX,
	numberDrawerAttrSx,
	textNumberDrawerSX,
	subTextNumberDrawerSx,
	textSubtitle2DrawerSX,
	textLittleSx,
	textLittlelinkTitleSX,
	buttonAplazoSX,
	titleIconSx,
	subTitleIconSx,
} from '@/components/blocks/ProductDetails/styles/aplazo';
import { Stack, Typography, styled, Divider, Button } from '@mui/material';
import { FC } from 'react';

const Img = styled('img')({
	height: '18px',
	marginLeft: '7px',
	maxWidth: '65.45px',
});

export const AplazoDrawerList: FC = () => (
	<Stack
		sx={{
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'left',
			paddingBottom: '30px',
		}}
	>
		<Stack>
			<Img
				src="images/aplazo/aplazo@2x.png"
				alt="Aplazo"
				sx={{ marginLeft: '0px', height: 'auto', width: '87px', maxWidth: '87px' }}
			/>
		</Stack>
		<Stack sx={{ marginTop: '20px' }}>
			<Typography sx={tileDescriptionDrawerSX}>
				{
					'Ahora puedes tener lo que quieras cuando quieras. Compra ahora y paga en 5 plazos quincenales'
				}
			</Typography>
		</Stack>
		<Stack sx={{ marginTop: '13px !important' }}>
			<Typography>
				<Typography sx={numberDrawerAttrSx}>{'1'}</Typography>
				<Typography sx={textNumberDrawerSX}>{'Elige tus productos favoritos'}</Typography>
			</Typography>
			<Typography sx={subTextNumberDrawerSx}>
				{'Agrega los productos a tu carrito de compra.'}
			</Typography>
		</Stack>
		<Stack sx={{ marginTop: '13px !important' }}>
			<Typography>
				<Typography sx={numberDrawerAttrSx}>{'2'}</Typography>
				<Typography sx={textNumberDrawerSX}>{'Elige Aplazo como forma de pago'}</Typography>
			</Typography>
			<Typography sx={subTextNumberDrawerSx}>
				{'Crea tu cuenta y agrega tu tarjeta de crédito o débito.'}
			</Typography>
		</Stack>
		<Stack sx={{ marginTop: '13px !important' }}>
			<Typography>
				<Typography sx={numberDrawerAttrSx}>{'3'}</Typography>
				<Typography sx={textNumberDrawerSX}>
					{'Paga el 20% del total de tu compra y el resto a plazos'}
				</Typography>
			</Typography>
			<Typography sx={subTextNumberDrawerSx}>{'Confirma tu compra.'}</Typography>
		</Stack>
		<Stack sx={{ marginTop: '13px !important', marginBottom: '18px' }}>
			<Typography>
				<Typography sx={numberDrawerAttrSx}>{'4'}</Typography>
				<Typography sx={textNumberDrawerSX}>{'Disfruta tu compra'}</Typography>
			</Typography>
			<Typography sx={subTextNumberDrawerSx}>{'Disfruta tus compras y paga despúes.'}</Typography>
		</Stack>

		<Divider />

		<Stack sx={{ marginTop: '18px' }}>
			<Typography sx={textSubtitle2DrawerSX}>{'¿POR QUÉ UTILIZAR APLAZO?'}</Typography>
		</Stack>
		<Stack sx={{ marginTop: '5px' }}>
			<Typography sx={tileDescriptionDrawerSX}>
				{'Compra ahora. Paga a plazos. Sin tarjeta de crédito'}
			</Typography>
		</Stack>
		<Stack
			sx={{
				marginTop: '10px !important',
			}}
		>
			<Typography>
				<Typography sx={textLittleSx}>{'Visita nuestras'}</Typography>
				<Linkable
					href="https://aplazo.mx/preguntas-frecuentes"
					type="inline"
					target={'_blank'}
					sx={textLittlelinkTitleSX}
				>
					{'Preguntas Frecuentes'}
				</Linkable>
			</Typography>
		</Stack>
		<Stack sx={{ marginTop: '8px' }}>
			<Button
				variant="contained"
				sx={buttonAplazoSX}
				href="https://customer.aplazo.mx/register/credentials"
				target="_blank"
			>
				{'Crear mi cuenta'}
			</Button>
		</Stack>
		<Stack sx={{ marginTop: '15px', display: 'flex', flexDirection: 'row' }}>
			<Stack justifyContent={'center'} sx={{ paddingRight: '17px' }}>
				<Img
					src="https://dpjye2wk9gi5z.cloudfront.net/wcsstore/DportenisStorefrontAssetStore/Attachment/2024/enero/aplazo/icon_3.png"
					alt="Aplazo"
					sx={{
						marginLeft: '0px',
						height: 'auto',
						width: 'auto',
						maxWidth: '34px',
					}}
				/>
			</Stack>
			<Stack>
				<Typography sx={titleIconSx}>{'Paga en 5 plazos quincenales'}</Typography>
				<Typography sx={subTitleIconSx}>
					{'Obtén más control sobre tus compras pagando el primer plazo al momento de la compra'}
				</Typography>
			</Stack>
		</Stack>
		<Stack sx={{ marginTop: '15px', display: 'flex', flexDirection: 'row' }}>
			<Stack justifyContent={'center'} sx={{ paddingRight: '17px' }}>
				<Img
					src="https://dpjye2wk9gi5z.cloudfront.net/wcsstore/DportenisStorefrontAssetStore/Attachment/2024/enero/aplazo/icon_2.png"
					alt="Aplazo"
					sx={{
						marginLeft: '0px',
						height: 'auto',
						width: 'auto',
						maxWidth: '34px',
					}}
				/>
			</Stack>
			<Stack>
				<Typography sx={titleIconSx}>{'Aprobación instantánea'}</Typography>
				<Typography sx={subTitleIconSx}>
					{
						'Registrate una vez, obten tu crédito de forma instantánea y comienza a comprar con Aplazo.'
					}
				</Typography>
			</Stack>
		</Stack>
		<Stack sx={{ marginTop: '15px', display: 'flex', flexDirection: 'row' }}>
			<Stack justifyContent={'center'} sx={{ paddingRight: '17px' }}>
				<Img
					src="https://dpjye2wk9gi5z.cloudfront.net/wcsstore/DportenisStorefrontAssetStore/Attachment/2024/enero/aplazo/icon_1.png"
					alt="Aplazo"
					sx={{
						marginLeft: '0px',
						height: 'auto',
						width: 'auto',
						maxWidth: '34px',
					}}
				/>
			</Stack>
			<Stack>
				<Typography sx={titleIconSx}>{'Simple y transpatente'}</Typography>
				<Typography sx={subTitleIconSx}>
					{
						'Olvidate de cargos extras y términos confusos, nuestro servicio es seguro y fácil de entender.'
					}
				</Typography>
			</Stack>
		</Stack>
	</Stack>
);
